module.exports = __webpack_public_path__ + "img/nav-right-with-contact-black-infiniti.bdc346d9.png";